import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.NonWarrantyPricePoint.List.IRequest;
type Response = Api.Core.NonWarrantyPricePoint.List.IResponse;
type Headers = Api.Core.NonWarrantyPricePoint.List.IHeaders;
const url = '/api/ProductManagement/NonWarrantyPricePoint';
export default async function nonWarrantyPricePointListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
